import { IProbability } from "@/@types/campaign-roulette";

export const convertProbabilitiesToPercentage = (probabilities: IProbability[]): IProbability[] => {
  return probabilities.map(prob => ({
    ...prob,
    prob: Math.round(prob.prob * 10000) / 100
  }));
};

export const adjustProbabilitiesToTotal100 = (probabilities: IProbability[]): IProbability[] => {
  if (probabilities.length === 0) return probabilities;
  
  const converted = [...probabilities];
  const total = converted.reduce((sum, p) => sum + p.prob, 0);
  const diff = 100 - total;
  
  if (Math.abs(diff) > 0.01) {
    const maxIndex = converted.reduce((maxIdx, curr, idx, arr) => 
      curr.prob > arr[maxIdx].prob ? idx : maxIdx, 0
    );
    converted[maxIndex].prob = Math.round((converted[maxIndex].prob + diff) * 100) / 100;
  }
  
  return converted;
};

export const processDefaultProbabilities = (defaultProbabilities: IProbability[]): IProbability[] => {
  const converted = convertProbabilitiesToPercentage(defaultProbabilities);
  return adjustProbabilitiesToTotal100(converted);
};

export const calculateTotalProbability = (probabilities: { prob: number | null | undefined }[]): number => {
  return probabilities.reduce((sum, probability) => {
    const prob = probability.prob;
    if (prob === null || prob === undefined || isNaN(prob)) {
      return sum + 0;
    }
    return sum + prob;
  }, 0);
};
